import { render, staticRenderFns } from "./setAssociationRelationshipModal.vue?vue&type=template&id=4ee3cfe6&scoped=true"
import script from "./setAssociationRelationshipModal.vue?vue&type=script&lang=js"
export * from "./setAssociationRelationshipModal.vue?vue&type=script&lang=js"
import style0 from "./setAssociationRelationshipModal.vue?vue&type=style&index=0&id=4ee3cfe6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee3cfe6",
  null
  
)

export default component.exports